"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headFragment = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _client = require("@apollo/client");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  fragment headFragment on Store {\n    id\n    adTracks {\n      googleSearchConsoleVerificationHtml\n      googleMerchantCenterVerificationCode\n      facebookPixelId\n      googleAnalyticsId\n      googleAdwordsConfig\n      googleTagManager\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// definition
var headFragment = (0, _client.gql)(_templateObject());
exports.headFragment = headFragment;